<template>
  <div class="new-study-set">
    <organization-breadcrumb :items="[$t('study_sets.curriculum'), $t('study_sets.create_study_set')]" />
    <div id="create-study-set-page">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :md="14">
          <h1 class="blue-color" style="text-align: center" v-if="createStudySetSteps.active == 1">{{ $t('study_sets.create_study_set') }}</h1>
          <h1 class="blue-color" style="text-align: center" v-else-if="createStudySetSteps.active == 2">{{ $t('study_sets.review_confirm') }}</h1>
          <h1 class="blue-color" style="text-align: center" v-else>{{ $t('study_sets.your_study_set') }}</h1>
          <div>
            <div class="study-set-create-main">
              <study-set-create-details
                ref="studysetdetail"
                v-if="createStudySetSteps.active == 1"
                :currentStep="createStudySetSteps.active"
                :componentStep="1"
                v-on:next-step="handleNextStep"
                v-on:previous-step="handlePreviousStep"
                v-on:assign-to-class="handleAssignStudySetToClass"
                :isAdmin="true"
                :editMode="editMode"
                :organizationType="currentOrganizationType"
              />
              <study-set-overview
                v-if="createStudySetSteps.active != 1"
                :currentStep="createStudySetSteps.active"
                :componentStep="2"
                v-on:next-step="handleConfirmDoneCreateStudySet"
                v-on:last-step="lastStep"
                v-on:edit-step="handleEdit"
                v-on:cancel="handleCancel"
                v-on:assign-to-class="handleAssignStudySetToClass"
                :studysetDetails="buildingStudySet"
                :organizationType="currentOrganizationType"
                :uploadId.sync="uploadId"
                :organizationId="currentOrganizationId"
              />
            </div>
            <study-set-create-footer :primaryPreviousText="$t('common.cancel')" :cancelActive="true" v-if="createStudySetSteps.active == 1" :primaryPreviousActive="false" :primaryAction="clickContinute" :primaryCancelAction="handleCancel" primaryText="Next" :previousText="$t('common.cancel')" />
          </div>
        </el-col>
      </el-row>
    </div>
    <create-study-set-success-modal
      :dialogVisible="modals.showCreateStudySetSuccessModal"
      v-on:closed="handleConfirmDoneCreateStudySet"
      v-on:new-set="handleCreateNewStudySet"
      v-on:assign-class="handleAssignStudySetToClass"
      :studySetName="membershipSelectedDisplayName"
      :countOfPhrases="countOfPhrases"
    />
    <leave-create-study-set-modal :dialogVisible="modals.showLeaveCreateStudySetModal" v-on:closed="modals.showLeaveCreateStudySetModal = false" v-on:leave="handleConfirmCancel" />
    <add-assignment-wrapper ref="addAssignment" v-on:reload="handleExit" />
    
  </div>
</template>

<script>
import StudySetCreateDetails from '@/components/studysets/create-studysets/StudySetCreateDetail'
import StudySetOverview from '@/components/studysets/create-studysets/StudySetOverview'
import StudySetCreateFooter from '@/components/studysets/create-studysets/StudySetCreateFooter'
import { mapGetters } from 'vuex'
import OrganizationBreadcrumb from '@/components/common/OrganizationBreadcrumb'
import CreateStudySetSuccessModal from '@/components/modals/studysets/CreateStudySetSuccessModal'
import LeaveCreateStudySetModal from '@/components/modals/studysets/LeaveCreateStudySetModal'
import AddAssignmentWrapper from '@/components/modals/studysets/AddAssignmentWrapper'

export default {
  components: {
    StudySetCreateDetails,
    StudySetOverview,
    StudySetCreateFooter,
    OrganizationBreadcrumb,
    CreateStudySetSuccessModal,
    LeaveCreateStudySetModal,
    AddAssignmentWrapper,
  },
  computed: {
    ...mapGetters({
      buildingStudySet: 'studysets/getBuildingStudySet',
      currentOrganizationType: 'organization/currentOrganizationType',
      currentOrganizationId: 'organization/currentOrganizationId',
      getCurrentStudySet: 'studysets/getCurrentStudySet'
    }),
    membershipSelectedDisplayName() {
      if (this.buildingStudySet && this.buildingStudySet.name) {
        return this.buildingStudySet.name
      }
      return ''
    },
    countOfPhrases() {
      if (this.buildingStudySet && this.buildingStudySet.phrases) {
        return this.buildingStudySet.phrases.length
      }
      return 0
    },
    studySetDetails() {
      return this.buildingStudySet
    }
  },
  data() {
    return {
      modals: {
        showInviteTeacherModal: false,
        showCreateStudySetSuccessModal: false,
        showLeaveCreateStudySetModal: false,
      },
      uploadId: null,
      inviteMode: null,
      editMode: false,
      createStudySetSteps: {
        active: 1,
        steps: [
          {
            title: this.$t('studysets.create_studyset_flow.details')
          },
          {
            title: this.$t('study_sets.review_confirm')
          }
        ]
      }
    }
  },
  methods: {
    clickContinute() {
      switch (this.createStudySetSteps.active) {
        case 1:
          this.modals.showModalSpellCheck = true;
          this.$refs.studysetdetail.handleContinueClick()
          break
        default:
          return
      }
    },
    handleNextStep(activeStep) {
      this.createStudySetSteps.active = activeStep + 1

      if (this.createStudySetSteps.active > 2) {
        this.modals.showCreateStudySetSuccessModal = true
      }
    },
    lastStep() {
      this.createStudySetSteps.active = 3
    },
    handlePreviousStep() {
      const activeStep = this.createStudySetSteps.active
      this.createStudySetSteps.active = activeStep - 1
    },
    handleEdit() {
      this.createStudySetSteps.active = 1
      this.editMode = true
    },
    handleAssignStudySetToClass() {
      this.modals.showCreateStudySetSuccessModal = false
      this.$refs.addAssignment.handleAssignToClassStudySet(this.getCurrentStudySet)
    },
    handleExit() {
      this.$store.dispatch('studysets/resetBuildingStudySet')
      return this.$router.push({
        name: 'studysets',
        params: {
          organizationId: this.currentOrganizationId
        }
      })
    },
    handleConfirmDoneCreateStudySet() {
      this.$store.dispatch('studysets/resetBuildingStudySet')
      this.modals.showCreateStudySetSuccessModal = false
      return this.$router.push({
        name: 'studysets',
        params: {
          organizationId: this.currentOrganizationId
        }
      })
    },
    handleCreateNewStudySet() {
      this.$store.dispatch('studysets/resetBuildingStudySet')
      this.createStudySetSteps.active = 1
      this.editMode = true
      this.modals.showCreateStudySetSuccessModal = false
    },
    handleConfirmCancel() {
      // leave
      // this.createStudySetSteps.active = 1
      this.$store.dispatch('studysets/resetBuildingStudySet')
      return this.$router.push({
        name: 'studysets',
        params: {
          organizationId: this.currentOrganizationId
        }
      })
    },
    handleCancel() {
      this.modals.showLeaveCreateStudySetModal = true
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch('studysets/getStudySetCategories')
    } catch (error) {
      error
    }
  },
  destroyed() {
    this.$store.dispatch('studysets/resetBuildingStudySet')
  }
}
</script>

<style lang="scss" scoped>
.new-study-set {
  width: 100%;
}
#create-study-set-page {
  margin: 24px;
  @media only screen and (max-width: 768px) {
    margin: 0 30px;
  }
  h1 {
    border: 0;
    font-size: 30px;
    line-height: 45px;
    font-weight: 700;
  }
  .study-set-create-steps {
    margin-top: 25px;
  }
  .study-set-create-main {
    background-color: white;
    padding: 40px 0px 10px 0px;
  }
  ::v-deep .base-create-header {
    padding-bottom: 34px;
  }
  ::v-deep .circle-step {
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 23px;
    width: 40px;
    height: 40px;
    display: inline-flex;
    justify-content: center;
    padding-top: 8px;
    margin-right: 16px;
  }
}

.success-info {
  .success {
    font-weight: bold;
    font-size: 22px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #46c779;
    line-height: 30px;
  }
  p {
    margin-top: 20px;
    font-weight: 300;
    font-size: 18px;
    color: #546873;
    margin: 0;
  }
}
::v-deep .create-study-set-com-disable {
  opacity: 0.5;
}
.line-separate {
  border: 1px solid#E6E6E6;
  margin-bottom: 32px;
}
</style>
